import {
  SwipeableDrawer,
  Typography,
  List,
  Box,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
  InputBase,
  IconButton,
  Button,
  Fade,
  Modal,
  Backdrop,
  Grid,
  useMediaQuery,
} from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";
import SettingsIcon from "@mui/icons-material/Settings";
import {
  PersonAdd,
  MonetizationOn,
  FeaturedPlayList,
  LocalOffer,
  Search,
  KeyboardBackspace,
  MoveToInbox,
  OndemandVideo,
} from "@mui/icons-material";
import packageJson from "../../../package.json";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import ColorLensIcon from "@mui/icons-material/ColorLens";
import { useCallback, useEffect, useState } from "react";

import { GuidedNav } from "../modals/GuidedTourComponent";
import { useRef } from "react";
import SelectTheme from "../modals/SelectTheme";
import { useDispatch, useSelector } from "react-redux";
import { handleFreeze } from "../../utils/common";
import { useThemes } from "../Theme/theme";
import Link from "../LinkTagComponent";
import useControlledNavigation from "../../hooks/useControlledNavigation";
import { setCustomModalAction } from "../../redux/reducers/controllNavigation";

const SettingsTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#30d5c8",
    color: "#fff",
  },
}));

function SettingsDrawer(props) {
  const { theme } = useThemes();

  const Freeze = useSelector(
    (state) => state.userPrefrenceandReducer?.financialYear?.freezestatus
  );
  let [modalOpen, setModalOpen] = useState(false);

  const navigate = useControlledNavigation();

  const { isBlocked } = useSelector((state) => state.controllNavigationSlice);



  const settings = [
    {
      menu: "Company Setup",
      title: (
        <Typography marginLeft={-4} fontSize={"13px"}>
          Company Setup
        </Typography>
      ),
      icon: (
        <MoveToInbox
          sx={{
            color: theme?.palette?.TmId.id.toString().includes("9")
              ? ""
              : theme.palette.input.font,
            fontSize: "15px",
            margin: "0px",
          }}
        />
      ),
      nav: "/companysetup",
    },
    {
      menu: "opening balances",
      title: (
        <Typography marginLeft={-4} fontSize={"13px"}>
          Opening Balances
        </Typography>
      ),
      icon: (
        <PersonAdd
          sx={{
            color: theme?.palette?.TmId.id.toString().includes("9")
              ? ""
              : theme.palette.input.font,
            fontSize: "15px",
          }}
        />
      ),
      nav: "/openingbalance",
    },
    {
      menu: "users & roles",
      title: (
        <Typography marginLeft={-4} fontSize={"13px"}>
          Users & Roles
        </Typography>
      ),
      icon: (
        <MonetizationOn
          sx={{
            color: theme?.palette?.TmId.id.toString().includes("9")
              ? ""
              : theme.palette.input.font,
            fontSize: "15px",
          }}
        />
      ),
      nav: "",
    },
    {
      menu: "prefrences",
      title: (
        <Typography marginLeft={-4} fontSize={"13px"}>
          Preference
        </Typography>
      ),
      icon: (
        <LocalOffer
          sx={{
            color: theme?.palette?.TmId.id.toString().includes("9")
              ? ""
              : theme.palette.input.font,
            fontSize: "15px",
          }}
        />
      ),
      nav: "",
    },
    {
      menu: "currencies",
      title: (
        <Typography marginLeft={-4} fontSize={"13px"}>
          Currencies
        </Typography>
      ),
      icon: (
        <FeaturedPlayList
          sx={{
            color: theme?.palette?.TmId.id.toString().includes("9")
              ? ""
              : theme.palette.input.font,
            fontSize: "15px",
          }}
        />
      ),
      nav: "",
    },
    {
      menu: "general settings",
      title: (
        <SettingsTooltip
          title="Click to set format for Voucher Number"
          followCursor
        >
          <Typography marginLeft={-4} fontSize={"13px"}>
            Voucher Settings
          </Typography>
        </SettingsTooltip>
      ),
      icon: (
        <SettingsTooltip
          title="Click to set format for Voucher Number"
          followCursor
        >
          <SettingsIcon
            sx={{ color: theme.palette.input.font, fontSize: "15px" }}
          />
        </SettingsTooltip>
      ),
      nav: "/defaultformats",
    },
    {
      menu: "financial year settings",
      title: (
        <Typography marginLeft={-4} fontSize={"13px"}>
          Financial Year Settings
        </Typography>
      ),
      icon: (
        <SettingsApplicationsIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes("9")
              ? ""
              : theme.palette.input.font,
            fontSize: "15px",
          }}
        />
      ),
      nav: "/financialyearsettings",
    },
    // {
    //   menu: 'Close Financial Year',
    //   title: <Typography marginLeft={-4} fontSize={'13px'}>Close Financial Year</Typography>,
    //   icon: <SettingsApplicationsIcon sx={{ color: theme.palette.input.font, fontSize: '15px' }} />,
    //   nav: '/create-financial-year',
    //
    // },
    // {
    //   menu: "Close Books of Accounts",
    //   title: (
    //     <Typography marginLeft={-4} fontSize={"13px"}>
    //       Close Books of Accounts
    //     </Typography>
    //   ),
    //   icon: (
    //     <SettingsApplicationsIcon
    //       sx={{ color: theme.palette.input.font, fontSize: "15px" }}
    //     />
    //   ),
    //   nav: "/closebooksofaccounts",
    // },
    {
      menu: "email settings",
      title: (
        <Typography marginLeft={-4} fontSize={"13px"}>
          Email Settings
        </Typography>
      ),
      icon: (
        <AlternateEmailIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes("9")
              ? ""
              : theme.palette.input.font,
            fontSize: "15px",
          }}
        />
      ),
      nav: "/emailsettings",
    },
    {
      menu: "invoice settings",
      title: (
        <Typography marginLeft={-4} fontSize={"13px"}>
          Invoice Settings
        </Typography>
      ),
      icon: (
        <SettingsApplicationsIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes("9")
              ? ""
              : theme.palette.input.font,
            fontSize: "15px",
          }}
        />
      ),
      nav: "/invoiceSettings",
    },
    {
      menu: "item settings",
      title: (
        <Typography marginLeft={-4} fontSize={"13px"}>
          Item Settings
        </Typography>
      ),
      icon: (
        <SettingsApplicationsIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes("9")
              ? ""
              : theme.palette.input.font,
            fontSize: "15px",
          }}
        />
      ),
      nav: "/ItemSettings",
    },
    {
      menu: "Payment settings",
      title: (
        <Typography marginLeft={-4} fontSize={"13px"}>
          Payment Settings
        </Typography>
      ),
      icon: (
        <SettingsApplicationsIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes("9")
              ? ""
              : theme.palette.input.font,
            fontSize: "15px",
          }}
        />
      ),
      nav: "/PaymentSettings",
    },
    {
      menu: "Party settings",
      title: (
        <Typography marginLeft={-4} fontSize={"13px"}>
          Party Settings
        </Typography>
      ),
      icon: (
        <AccountCircleIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes("9")
              ? ""
              : theme.palette.input.font,
            fontSize: "15px",
          }}
        />
      ),
      nav: "/partySettings",
    },
  ];
  const otherSettings = [
    // {
    //   menu: "Add Item",
    //   title: (
    //     <Typography marginLeft={-4} fontSize={"13px"}>
    //       Add Item
    //     </Typography>
    //   ),
    //   icon: (
    //     <PersonAdd
    //       sx={{
    //         color: theme?.palette?.TmId.id.toString().includes("9")
    //           ? ""
    //           : theme.palette.input.font,
    //         fontSize: "15px",
    //       }}
    //     />
    //   ),
    //   nav: "/additem",
    // },
    // {
    //   menu: "Add Customer",
    //   title: (
    //     <Typography marginLeft={-4} fontSize={"13px"}>
    //       Add Customer
    //     </Typography>
    //   ),
    //   icon: (
    //     <MonetizationOn
    //       sx={{
    //         color: theme?.palette?.TmId.id.toString().includes("9")
    //           ? ""
    //           : theme.palette.input.font,
    //         fontSize: "15px",
    //       }}
    //     />
    //   ),
    //   nav: "/addcustomer",
    // },
    // {
    //   menu: "Add Supplier",
    //   title: (
    //     <Typography marginLeft={-4} fontSize={"13px"}>
    //       Add Supplier
    //     </Typography>
    //   ),
    //   icon: (
    //     <FeaturedPlayList
    //       sx={{
    //         color: theme?.palette?.TmId.id.toString().includes("9")
    //           ? ""
    //           : theme.palette.input.font,
    //         fontSize: "15px",
    //       }}
    //     />
    //   ),
    //   nav: "/addsupplier",
    // },
    {
      menu: "sms",
      title: (
        <Typography marginLeft={-4} fontSize={"13px"}>
          SMS Notifications
        </Typography>
      ),
      icon: (
        <LocalOffer
          sx={{
            color: theme?.palette?.TmId.id.toString().includes("9")
              ? ""
              : theme.palette.input.font,
            fontSize: "15px",
          }}
        />
      ),
      nav: "",
    },
    {
      menu: "automation",
      title: (
        <Typography marginLeft={-4} fontSize={"13px"}>
          Automation
        </Typography>
      ),
      icon: (
        <MoveToInbox
          sx={{
            color: theme?.palette?.TmId.id.toString().includes("9")
              ? ""
              : theme.palette.input.font,
            fontSize: "15px",
          }}
        />
      ),
      nav: "",
    },
    {
      menu: "theme",
      title: (
        <Typography marginLeft={-4} fontSize={"13px"}>
          Appearance
        </Typography>
      ),
      icon: (
        <ColorLensIcon
          sx={{
            color: theme?.palette?.TmId.id.toString().includes("9")
              ? ""
              : theme.palette.input.font,
            fontSize: "15px",
          }}
        />
      ),
      // nav: `${new URL(window.location.href).pathname}`,
    },
    {
      menu: "Tutorial",
      title: (
        <Typography marginLeft={-4} fontSize={"13px"}>
          Tutorial
        </Typography>
      ),
      icon: (
        <OndemandVideo
          sx={{
            color: theme?.palette?.TmId.id.toString().includes("9")
              ? ""
              : theme.palette.input.font,
            fontSize: "15px",
          }}
        />
      ),
      nav: `/?active=BalanceSheet`,
    },
  ];

  let [searchSettings, setSearchSettings] = useState("");
  const modalClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setModalOpen(false);
    }
  };
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const childRef = useRef(null);

   const dispatch =useDispatch()

    const gauidedNav = () => {
    localStorage.setItem("tutorialStep", 0);
    localStorage.setItem("FirstTutorial", 1);
    localStorage.setItem("tutorialCompleted", "false");
    childRef.current.startGuidedNavigation();
    
  };

  return (
    <>
      <SelectTheme
        isOpen={modalOpen}
        onClose={modalClose}
        setModalopen={setModalOpen}
      />
      {props.open && (
        <SwipeableDrawer
          id="Swipe000"
          anchor="right"
          open={props.open}
          onClose={() => props.setOpen(false)}
          onOpen={() => props.setOpen(true)}
        >
          <Box
            sx={{
              padding: { xs: "10px", sm: "30px" },
              width: { xs: "250px", sm: "400px" },
              // backgroundColor: theme.palette.bodyGray.secondary,
            }}
            role="presentation"
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <GuidedNav props={"close"} ref={childRef} />
              <KeyboardBackspace
                className={props.open ? "Z" : ""}
                style={{ cursor: "pointer" }}
                onClick={() => props.setOpen(false)}
                sx={{ fontSize: "30px", marginRight: 1, fontWeight: "0" }}
              />
              <Typography fontWeight={600} fontSize="18px">
                Settings
              </Typography>
            </Box>

            <Paper
              sx={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                border: " 1px solid #C0C0C0",
                boxShadow: "none",
                marginTop: "15px",
                marginBottom: "15px",
              }}
            >
              <InputBase
                sx={{ ml: 1, flex: 1 }}
                value={searchSettings}
                onChange={(e) => {
                  setSearchSettings(e.target.value);
                }}
                placeholder="Search"
                inputProps={{ "aria-label": "search google maps" }}
              />
              <IconButton
                type="button"
                sx={{ padding: "8px 10px" }}
                aria-label="search"
              >
                <Search />
              </IconButton>
            </Paper>
            <List
              sx={{
                ".css-1nx70b6-MuiButtonBase-root-MuiListItemButton-root": {
                  padding: "8px 10px",
                  flex: 1,
                },
              }}
            >
              <Typography
                marginBottom={"10px"}
                fontWeight={600}
                fontSize="16px"
              >
                Advanced Settings
              </Typography>
              <Box
                className="custom-scrollbar"
                sx={{
                  height: "200px",
                  overflowY: "scroll",
                  overflowX: "hidden",
                  // background: !theme?.palette?.TmId.id.toString().includes("9")
                  //   ? "#F5F5F5" : "#1E1E1E",
                  pl: "10px",
                  borderRadius: "5px",
                  "&::-webkit-scrollbar-track": {
                    background: theme?.palette?.TmId.id.toString().includes("9")
                      ? "#353535"
                      : "#ffffff",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    borderColor: theme?.palette?.TmId.id
                      .toString()
                      .includes("9")
                      ? "#353535"
                      : "#ffffff",
                  },
                  // scrollbarWidth: "thin",
                }}
              >
                <Grid
                  container
                  rowSpacing={1}
                  columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                >
                  {settings
                    .filter(
                      (z) =>
                        z.menu
                          .toLowerCase()
                          .indexOf(searchSettings.toLowerCase()) >= 0
                    )
                    .map((item, index) => (
                      <Link
                        style={{
                          width: isMobile ? "100%" : "50%",
                          textDecoration: "none",
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <ListItem
                          key={index}
                          disablePadding
                          onClick={() => {
                            navigate(item.nav);
                            props.setOpen(false);
                          }}
                        >
                          <ListItemButton>
                            <ListItemIcon>{item.icon}</ListItemIcon>
                            <ListItemText
                              sx={{
                                color: theme?.palette?.TmId.id
                                  .toString()
                                  .includes("9")
                                  ? "white"
                                  : theme.palette.input.font,
                              }}
                              primary={item.title}
                            />
                          </ListItemButton>
                        </ListItem>
                      </Link>
                    ))}
                </Grid>
              </Box>
            </List>
            <List
              sx={{
                marginTop: "10px",
                ".css-1nx70b6-MuiButtonBase-root-MuiListItemButton-root": {
                  padding: "8px 10px",
                  flex: 1,
                },
              }}
            >
              <Typography
                marginBottom={"10px"}
                fontWeight={600}
                fontSize="16px"
              >
                Quick Links
              </Typography>
              <Box
                className="custom-scrollbar"
                sx={{
                  height: "200px",
                  overflowY: "scroll",
                  overflowX: "hidden",
                  borderRadius: "5px",
                  // background: !theme?.palette?.TmId.id.toString().includes("9")
                  //   ? "#F5F5F5" : "#1E1E1E",
                  pl: "10px",
                  "&::-webkit-scrollbar-track": {
                    background: theme?.palette?.TmId.id.toString().includes("9")
                      ? "#353535"
                      : "#ffffff",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    borderColor: theme?.palette?.TmId.id
                      .toString()
                      .includes("9")
                      ? "#353535"
                      : "#ffffff",
                  },
                  // scrollbarWidth: "thin",
                }}
              >
                <Grid
                  container
                  rowSpacing={1}
                  columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                >
                  {otherSettings
                    .filter(
                      (z) =>
                        z.menu
                          .toLowerCase()
                          .indexOf(searchSettings.toLowerCase()) >= 0
                    )
                    .map((item, index) => (
                      <Link
                        id={item.menu === "theme" ? "theme" : ""}
                        style={{
                          width: isMobile ? "100%" : "50%",
                          textDecoration: "none",
                          color: theme.palette.input.font,
                        }}
                        onClick={(e) => {
                          if (item?.nav == undefined) {
                            e.preventDefault();
                            
                          }
                        }}
                      >
                        <ListItem
                          key={index}
                          disablePadding
                          onClick={() => {
                            if(item.menu !=="Tutorial"){

                              props.setOpen(false);
                            }
                            if (item.menu === "theme") {
                              setModalOpen(true);
                            } else {
                              if (
                                Freeze === 1 &&
                                [
                                  "/additem",
                                  "/addcustomer",
                                  "/addsupplier",
                                ]?.includes(item.nav)
                              ) {
                                return handleFreeze();
                              }
                              navigate(item.nav);
                              if (item.menu === "Tutorial"&& !isBlocked) {
                               gauidedNav()
                              props.setOpen(false);

                              }
                              else{
                                dispatch(setCustomModalAction({key:"modalName",value:"guidedNav"}))
                                dispatch(setCustomModalAction({key:"onLeaveFunction",value:()=>gauidedNav()}))
                              // props.setOpen(false);

                              }
                            }
                          }}
                        >
                          <ListItemButton>
                            <ListItemIcon>
                              {item.icon}
                              {/* <ListItemText sx={{ color: '#b5b5b5',  }} primary={item.icon} /> */}
                            </ListItemIcon>
                            <ListItemText
                              sx={{
                                color: theme?.palette?.TmId.id
                                  .toString()
                                  .includes("9")
                                  ? ""
                                  : theme.palette.input.font,
                              }}
                              primary={item.title}
                            />
                          </ListItemButton>
                        </ListItem>
                      </Link>
                    ))}
                </Grid>
              </Box>
            </List>
            <Box
              sx={{
                // backgroundColor: theme.palette.bodyGray.secondary,
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "50px", // Set a fixed height or adjust as needed
                color: "#b5b5b5",
                // backgroundColor: 'rgba(0, 0, 0, 0.1)', // Optional background color for visibility
              }}
            >
              Version {packageJson.version}
            </Box>
          </Box>
        </SwipeableDrawer>
      )}
    </>
  );
}

export default SettingsDrawer;
